/* eslint-disable jsx-a11y/label-has-associated-control */

import React from "react";
import { useContext } from "../../../context";

export function Email() {
  const { appointment } = useContext();

  return (
    <div className="detail-row">
      <label>Email:</label>
      <span>{appointment.booking?.email}</span>
    </div>
  );
}
